import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, vModelSelect as _vModelSelect, normalizeClass as _normalizeClass, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, resolveDirective as _resolveDirective, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "mt-5" }
const _hoisted_2 = { class: "mb-3" }
const _hoisted_3 = {
  key: 0,
  class: "invalid-feedback",
  role: "alert"
}
const _hoisted_4 = { class: "mb-3" }
const _hoisted_5 = { class: "mb-3 row" }
const _hoisted_6 = { class: "col-md-8" }
const _hoisted_7 = { class: "mb-3 row" }
const _hoisted_8 = { class: "col-md-8" }
const _hoisted_9 = { class: "mb-3 row" }
const _hoisted_10 = { class: "col-md-8" }
const _hoisted_11 = ["value"]
const _hoisted_12 = { class: "mb-3 row" }
const _hoisted_13 = { class: "col-md-8" }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = ["aria-label"]
const _hoisted_16 = ["aria-label"]
const _hoisted_17 = { class: "d-block" }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = ["href"]
const _hoisted_20 = { key: 1 }
const _hoisted_21 = ["href", "aria-label"]
const _hoisted_22 = { key: 1 }
const _hoisted_23 = { key: 2 }
const _hoisted_24 = ["onClick", "aria-label"]
const _hoisted_25 = ["onClick", "aria-label"]
const _hoisted_26 = { key: 4 }
const _hoisted_27 = ["onClick", "aria-label"]
const _hoisted_28 = { key: 6 }
const _hoisted_29 = ["onClick", "aria-label"]
const _hoisted_30 = { key: 1 }

import BGrid from "../BGrid/BGrid.vue";
import type {BTableColumn} from "../BTable/BTable.types";
import {computed, onMounted, reactive, ref} from "vue";
import type {Audit, AuditDocument, AuditReviewDocument, UploadDocumentRequest} from "@/audit.types";
import {storeToRefs} from "pinia";
import {useAuditDocumentStore} from "@/stores/auditDocumentStore";
import {mixed, number, object, string} from "yup";
import {useFormValidation} from "@/validation";
import {FormModal} from "../Misc";
import {BInput, BTextarea, BFileInput} from "../Fields";

import {useAuditDocumentTemplateStore} from "@/stores/auditDocumentTemplateStore";
import {debounce} from "vue-debounce";

import {useConfirmDialog} from "@/composable/useConfirmDialog";

export default /*@__PURE__*/_defineComponent({
  __name: 'AuditDetailsDocuments',
  props: {
    id: {},
    audit: {},
    runAudits: { type: Boolean },
    createAudits: { type: Boolean }
  },
  setup(__props: any) {

const {confirm} = useConfirmDialog();

var updateData = debounce(() => getData(), "15000ms");
const auditDocumentStore = useAuditDocumentStore();
const auditDocumentTemplateStore = useAuditDocumentTemplateStore();
const {loading} = storeToRefs(auditDocumentTemplateStore);

const canDelete = computed(() => props.runAudits);
const canRequestDocument = computed(() => props.runAudits && props.audit.statusCode != "AC");

const props = __props;

const review = ref({} as AuditReviewDocument);
const isShowReviewEditor = ref(false);

const selectedId = ref(0);

const isAuditEditable = computed(() => {
    return props.audit.statusCode != "AC";
});

const columns = reactive<BTableColumn[]>([
    {
        key: "name",
        text: "Name",
        sortable: false,
        value: (item) => item["name"],
    },
    {
        key: "template",
        text: "Template",
        sortable: false,
        value: (item) => item.description,
    },
    {
        key: "status",
        text: "Status",
        sortable: false,
        value: (item) => item["status"],
    },

    {
        key: "agencyAction",
        text: "",
        sortable: false,
        value: (item) => 2,
    },

    {
        key: "actions",
        text: "",
        sortable: false,
        class: (item) => ["text-nowrap text-end"],
        value: (item) => 2,
    },
]);

const item = ref({} as AuditDocument);
const schema = object<AuditDocument>({
    name: string().required().label("Name"),
});

const {handleSubmit, errors, resetValidation} = useFormValidation();

const addDocument = async () => {
    if (await handleSubmit(schema, item.value)) {
        item.value.auditId = props.id;
        await auditDocumentStore.create(item.value);
        await getData();
        hideCreateEditor();
    }
};

const deleteDocument = async (id: number) => {
    const shouldProceed = await confirm("Delete Confirmation", "Are You Sure?");
    if (shouldProceed) {
        await auditDocumentStore.deleteItem(id);
        await getData();
    }
};
const isShowCreateEditor = ref(false);

const hideCreateEditor = () => {
    isShowCreateEditor.value = false;
};

const showCreateEditor = () => {
    resetValidation();
    isShowCreateEditor.value = true;
    item.value = {} as AuditDocument;
    item.value.documentTemplateId = null;
};

const hideUploadDocument = () => {
    isShowUploadDocument.value = false;
};

const isShowUploadDocument = ref(false);

const showUploadDocument = (id: number) => {
    resetValidation();
    uploadDocumentRequest.value = {} as UploadDocumentRequest;
    uploadDocumentRequest.value.id = id;
    isShowUploadDocument.value = true;
};

const uploadDocumentRequest = ref<UploadDocumentRequest>({} as UploadDocumentRequest);

const uploadDocumentSchema = object<UploadDocumentRequest>({
    id: number().required(),
    file: mixed().required().label("File"),
});

const uploadDocument = async () => {
    if (await handleSubmit(uploadDocumentSchema, uploadDocumentRequest.value)) {
        await auditDocumentStore.upload(uploadDocumentRequest.value);
        await getData();
        hideUploadDocument();
    }
};

const showReviewEditor = (id: number) => {
    resetValidation();
    review.value = {} as AuditReviewDocument;
    review.value.id = id;
    review.value.status = null;
    isShowReviewEditor.value = true;
};

const hideReviewEditor = () => {
    isShowReviewEditor.value = false;
};

const reviewSchema = object<AuditReviewDocument>({
    status: string().required().label("Status"),
});

const reviewDocument = async () => {
    if (await handleSubmit(reviewSchema, review.value)) {
        await auditDocumentStore.review(review.value);
        hideReviewEditor();
        await getData();
    }
};

const getData = async () => {
    await auditDocumentStore.list(props.id);
    await updateData();
};

onMounted(async () => {
    await getData();
    await auditDocumentTemplateStore.list();
});

return (_ctx: any,_cache: any) => {
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(FormModal), {
      title: "Review Document",
      modelValue: isShowReviewEditor.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((isShowReviewEditor).value = $event)),
      onSubmit: reviewDocument,
      loading: _unref(loading)
    }, {
      default: _withCtx(() => [
        _createElementVNode("fieldset", null, [
          _createElementVNode("div", _hoisted_2, [
            _cache[10] || (_cache[10] = _createElementVNode("label", {
              for: "reviewStatus",
              class: "form-label"
            }, "Status", -1)),
            _withDirectives(_createElementVNode("select", {
              id: "reviewStatus",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((review.value.status) = $event)),
              class: _normalizeClass(["form-select", {'is-invalid': !!_unref(errors).status}])
            }, [...(_cache[9] || (_cache[9] = [
              _createElementVNode("option", { value: null }, "Select Status", -1),
              _createElementVNode("option", { value: "DR" }, "Reject", -1),
              _createElementVNode("option", { value: "DA" }, "Accept", -1)
            ]))], 2), [
              [_vModelSelect, review.value.status]
            ]),
            (_unref(errors).status)
              ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_unref(errors).status), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_4, [
            _cache[11] || (_cache[11] = _createElementVNode("label", {
              for: "reviewComment",
              class: "form-label"
            }, "Comment", -1)),
            _withDirectives(_createElementVNode("textarea", {
              type: "text",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((review.value.comment) = $event)),
              id: "reviewComment",
              class: "form-control"
            }, "                    ", 512), [
              [_vModelText, review.value.comment]
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "loading"]),
    _createVNode(_unref(FormModal), {
      title: "Request Document",
      modelValue: isShowCreateEditor.value,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((isShowCreateEditor).value = $event)),
      onSubmit: addDocument,
      loading: _unref(loading)
    }, {
      default: _withCtx(() => [
        _createElementVNode("fieldset", null, [
          _createElementVNode("div", _hoisted_5, [
            _cache[12] || (_cache[12] = _createElementVNode("div", { class: "col-md-3" }, [
              _createElementVNode("label", {
                for: "documentName",
                class: "col-form-label"
              }, "Name:")
            ], -1)),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_unref(BInput), {
                modelValue: item.value.name,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((item.value.name) = $event)),
                name: "name",
                class: "form-control",
                error: _unref(errors).name
              }, null, 8, ["modelValue", "error"])
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _cache[13] || (_cache[13] = _createElementVNode("div", { class: "col-md-3" }, [
              _createElementVNode("label", {
                for: "documentDescription",
                class: "col-form-label"
              }, "Description:")
            ], -1)),
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_unref(BTextarea), {
                name: "documentDescription",
                modelValue: item.value.description,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((item.value.description) = $event)),
                class: "form-control",
                error: _unref(errors).description
              }, null, 8, ["modelValue", "error"])
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _cache[15] || (_cache[15] = _createElementVNode("div", { class: "col-md-3" }, [
              _createElementVNode("label", {
                for: "documentTemplate",
                class: "col-form-label"
              }, "Document Template:")
            ], -1)),
            _createElementVNode("div", _hoisted_10, [
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((item.value.documentTemplateId) = $event)),
                id: "documentTemplate",
                class: "form-select"
              }, [
                _cache[14] || (_cache[14] = _createElementVNode("option", { value: null }, "Without Document Template", -1)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(auditDocumentTemplateStore).items, (item) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: item.id,
                    value: item.id
                  }, _toDisplayString(item.name), 9, _hoisted_11))
                }), 128))
              ], 512), [
                [_vModelSelect, item.value.documentTemplateId]
              ])
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "loading"]),
    _createVNode(_unref(FormModal), {
      title: "Upload Document",
      modelValue: isShowUploadDocument.value,
      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((isShowUploadDocument).value = $event)),
      onSubmit: uploadDocument,
      loading: _unref(loading)
    }, {
      default: _withCtx(() => [
        _createElementVNode("fieldset", null, [
          _createElementVNode("div", _hoisted_12, [
            _cache[16] || (_cache[16] = _createElementVNode("div", { class: "col-md-3" }, [
              _createElementVNode("label", {
                for: "uploadFile",
                class: "col-form-label"
              }, "File:")
            ], -1)),
            _createElementVNode("div", _hoisted_13, [
              _createVNode(_unref(BFileInput), {
                modelValue: uploadDocumentRequest.value.file,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((uploadDocumentRequest.value.file) = $event)),
                name: "uploadFile",
                error: _unref(errors).file
              }, null, 8, ["modelValue", "error"])
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "loading"]),
    _createVNode(BGrid, {
      caption: "List of documents",
      tableOptions: _unref(auditDocumentStore).tableOptions,
      filterableFields: _unref(auditDocumentStore).filterableFields,
      filterOptions: _unref(auditDocumentStore).filterOptions,
      onOptionChange: getData,
      items: _unref(auditDocumentStore).items,
      columns: columns,
      loading: _unref(auditDocumentStore).loading
    }, {
      beforeFilter: _withCtx(() => [
        (canRequestDocument.value)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              type: "button",
              class: "btn btn-primary",
              onClick: _withModifiers(showCreateEditor, ["prevent"])
            }, " Request Document "))
          : _createCommentVNode("", true)
      ]),
      "cell.incidentNumber": _withCtx(({item, column}) => [
        _createElementVNode("span", null, _toDisplayString(item.incidentNumber), 1)
      ]),
      "cell.status": _withCtx(({item, column}) => [
        _createTextVNode(_toDisplayString(item.status) + " ", 1),
        (item.statusCode !== 'DU' && item.statusCode !== 'DA')
          ? (_openBlock(), _createElementBlock("span", _hoisted_14, [
              (item.comment)
                ? _withDirectives((_openBlock(), _createElementBlock("i", {
                    key: 0,
                    class: "bi bi-info-circle-fill text-info",
                    "aria-label": `Status comment: ${item.comment}`,
                    role: "img"
                  }, null, 8, _hoisted_15)), [
                    [_directive_tooltip, item.comment]
                  ])
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ]),
      "cell.name": _withCtx(({item, column}) => [
        _createTextVNode(_toDisplayString(item.name) + " ", 1),
        (item.description)
          ? _withDirectives((_openBlock(), _createElementBlock("i", {
              key: 0,
              class: "bi bi-info-circle-fill text-info",
              "aria-label": `Description: ${item.description}`,
              role: "img"
            }, null, 8, _hoisted_16)), [
              [_directive_tooltip, item.description]
            ])
          : _createCommentVNode("", true)
      ]),
      "cell.review": _withCtx(({item, column}) => [...(_cache[17] || (_cache[17] = []))]),
      "cell.template": _withCtx(({item, column}) => [
        (item.documentTemplateFileId)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("span", _hoisted_17, [
                _createTextVNode(_toDisplayString(item.documentTemplateName) + " ", 1),
                (item.documentTemplateUpdatedOn)
                  ? (_openBlock(), _createElementBlock("small", _hoisted_18, "(Updated at " + _toDisplayString(item.documentTemplateUpdatedOn) + ")", 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("a", {
                class: "btn btn-secondary btn-sm mt-2",
                href: `api/v1/audit/file/${item.documentTemplateFileId}`
              }, " View Template ", 8, _hoisted_19)
            ], 64))
          : (_openBlock(), _createElementBlock("span", _hoisted_20))
      ]),
      "cell.agencyAction": _withCtx(({item}) => [
        (item.fileId && item.hasFileContent)
          ? (_openBlock(), _createElementBlock("a", {
              key: 0,
              class: "btn btn-secondary btn-sm me-2",
              href: `api/v1/audit/file/${item.fileId}`,
              download: "",
              "aria-label": `View document for ${item.name}`
            }, " View Document", 8, _hoisted_21))
          : (_openBlock(), _createElementBlock("span", _hoisted_22)),
        (item.statusCode !== 'DU' && item.statusCode !== 'DA')
          ? (_openBlock(), _createElementBlock("span", _hoisted_23, [
              (isAuditEditable.value && item.statusCode == 'DN' && !__props.runAudits)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    onClick: _withModifiers(($event: any) => (showUploadDocument(item.id)), ["prevent"]),
                    class: "btn btn-primary btn-sm me-2",
                    "aria-label": `Upload document for ${item.name}`
                  }, " Upload Document ", 8, _hoisted_24))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        (isAuditEditable.value && (item.statusCode == 'DR' || item.statusCode == 'DU') && !__props.runAudits)
          ? (_openBlock(), _createElementBlock("button", {
              key: 3,
              type: "button",
              onClick: _withModifiers(($event: any) => (showUploadDocument(item.id)), ["prevent"]),
              class: "btn btn-primary btn-sm me-2",
              "aria-label": `Replace document for ${item.name}`
            }, " Replace Document ", 8, _hoisted_25))
          : (_openBlock(), _createElementBlock("span", _hoisted_26)),
        (isAuditEditable.value && __props.runAudits && item.statusCode == 'DU')
          ? (_openBlock(), _createElementBlock("button", {
              key: 5,
              class: "btn btn-primary btn-sm me-2",
              onClick: _withModifiers(($event: any) => (showReviewEditor(item.id)), ["prevent"]),
              "aria-label": `Provide feedback for ${item.name}`
            }, " Provide Feedback ", 8, _hoisted_27))
          : (_openBlock(), _createElementBlock("span", _hoisted_28))
      ]),
      "cell.actions": _withCtx(({item}) => [
        (canDelete.value && isAuditEditable.value)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              onClick: ($event: any) => (deleteDocument(item.id)),
              type: "button",
              class: "btn btn-sm btn-danger",
              "aria-label": `Delete document ${item.name}`
            }, " Delete ", 8, _hoisted_29))
          : (_openBlock(), _createElementBlock("span", _hoisted_30))
      ]),
      _: 1
    }, 8, ["tableOptions", "filterableFields", "filterOptions", "items", "columns", "loading"])
  ]))
}
}

})